const CategoryCards = class CategoryCards {

    constructor(config) {
        this.categoryItem = config.categoryItem
    }

    init() {

        let catItem = this.categoryItem;

        $(catItem).on("mouseenter", function() {
            let $this = $(this);
            $this.css('z-index', '2');

            setTimeout(function () {
                $this.css('z-index', '2');
            },100);
            TweenMax.to($this, 0.3, {
                scale: 1.1,
                force3D: "auto",
                ease: Back.easeOut.config(1)
            });
        }).on("mouseleave", function() {
            let $this = $(this);

            $this.css('z-index', '1');

            setTimeout(function () {
                $this.css('z-index', '0');
            },200);

            TweenMax.to($this, 0.3, {
                scale: 1,
                force3D: "auto",
                ease: Back.easeOut.config(1)
            });
        });
    }
};

export {CategoryCards}


// WEBPACK FOOTER //
// ./static/js/components/CategoryCards.js